import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    length: number;
    hasClick: boolean;
  }>()
  .create(({ theme, length, hasClick }) => ({
    barContainer: {
      height: 'calc((100% - 3rem) / 5)',
      [theme.breakpoints.down('xxl')]: {
        height: 'calc((100% - 6rem) / 5)' // Adjust height for xl breakpoint
      },
      [theme.breakpoints.down('xl')]: {
        height: 'calc((100% - 3rem) / 5)'
      }
    },
    percentageBarCardContent: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%'
    },
    contentContainer: {
      height: '100%',
      width: '100%',
      justifyContent: 'space-around'
    },
    progressBar: {
      height: '0.625rem',
      width: '100%',
      backgroundColor: theme.vars.palette.grey[300],
      borderRadius: 10,
      cursor: hasClick ? 'pointer' : 'default',
      '& .MuiLinearProgress-bar': {
        borderRadius: 10
      },
      [theme.breakpoints.down('xxl')]: {
        height: '0.3rem' // Adjust height for xl breakpoint
      },
      [theme.breakpoints.down('xl')]: {
        height: '0.625rem' // Ensure it remains consistent for xl and below
      },
      [theme.breakpoints.down('md')]: {
        height: '0.5rem'
      }
    },
    ticketNumber: {
      color: theme.vars.palette.text.secondary,
      marginLeft: theme.spacing(1)
    },
    ticketPercent: {
      color: theme.vars.palette.text.secondary,
      float: 'right'
    },
    labelText: {
      fontSize: '0.875rem',
      [theme.breakpoints.down('xxl')]: {
        fontSize: length > 5 ? '0.6rem' : '0.75rem' // Adjust fontsize for xl breakpoint
      },
      [theme.breakpoints.down('xl')]: {
        fontSize: '0.75rem' // Ensure it remains consistent for xl and below
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '0.6rem'
      }
    },
    noDataBox: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%'
    }
  }));

export default useStyles;
